import React, { useMemo } from "react";
import { getMovementRollItems } from "~/rules/rollableItems";
import styles from "~/pages/CharacterSheet/widgets/MovementCard/MovementCard.module.scss";
import GlossaryInfoIcon from "~/widgets/GlossaryInfoIcon/GlossaryInfoIcon";

export interface MovementCardProps {
  value: number;
  onRoll?: (skillName: string, poolSize: number, flatHits?: number) => void;
}

/**
 * MovementCard widget for displaying character movement stat.
 * Renders a highlighted card with the movement value and roll buttons for combat movement.
 * Uses centralized movement roll definitions from rules/rollableItems.ts.
 */
const MovementCard: React.FC<MovementCardProps> = ({ value, onRoll }) => {
  // Get movement roll items from centralized rules
  const movementItems = useMemo(() => getMovementRollItems(value), [value]);

  const getButtonLabel = (name: string): string => {
    // Extract the first word ("Half" or "Full") from the movement name
    return name.split(' ')[0];
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.title}>Movement</span>
        <GlossaryInfoIcon glossaryId="Movement Speed" />
      </div>

      {onRoll && movementItems.length > 0 && (
        <div className={styles.buttonGrid}>
          {movementItems.map((item) => (
            <button
              key={item.name}
              type="button"
              onClick={() => onRoll(item.name, item.pool)}
              className={styles.button}
              title={`Roll ${item.pool}d6 for ${item.name}`}
            >
              <span className={styles.buttonLabel}>{getButtonLabel(item.name)}</span>
              <span className={styles.buttonValue}>{item.pool}d6</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MovementCard;
